import React, { useState, useEffect, useContext } from 'react';
import { Field, Formik, setNestedObjectValues } from "formik";
import * as Yup from "yup";
import { AuthContext } from "../../AuthContext";
import { useViewPort } from "../Hooks/useViewPort";
import ReactBootstrap, { Dropdown, FormGroup, Form, Row } from 'react-bootstrap';
import { getAPI } from '../GdacsAPI';
import ProgressBar from 'react-bootstrap/ProgressBar';
import { GdacsTimeline } from "../Layout/GdacsTimeline";


const UserCredentials = (props) => {
    const authContext = useContext(AuthContext);
    const [events, setEvents] = React.useState([]);
    const [countries, setCountries] = React.useState([]);
    const [organizationtypes, setOrganizationsTypes] = React.useState([]);
    const [emailOpt, setEmailOpt] = React.useState([{ id: 1, description: "Html", }, { id: 2, description: "Text", }]);
    const params = props.params;
    const { width } = useViewPort();
    const [navIndex, setNavIndex] = React.useState(props.navIndex);
    const breakpoint = 620;
    const now = 60;
    const [utcOffset, setUtcOffset] = React.useState([{ id: 0, description: "UTC", }, { id: 1, description: "UTC + 1", }, { id: 2, description: "UTC + 2", }, { id: 3, description: "UTC + 3", }, { id: 4, description: "UTC + 4", }, { id: 5, description: "UTC + 5", }, { id: 6, description: "UTC + 6", }, { id: 7, description: "UTC + 7", }, { id: 8, description: "UTC + 8", },
    { id: 9, description: "UTC + 9", }, { id: 10, description: "UTC + 10", }, { id: 11, description: "UTC + 11", }, { id: 12, description: "UTC + 12", }, { id: -12, description: "UTC - 12", }, { id: -11, description: "UTC - 11", }, { id: -10, description: "UTC - 10", }, { id: -9, description: "UTC - 9", }, { id: -8, description: "UTC - 8", }, { id: -7, description: "UTC - 7", },
    { id: -6, description: "UTC - 6", }, { id: -5, description: "UTC - 5", }, { id: -4, description: "UTC - 4", }, { id: -3, description: "UTC - 3", }, { id: -2, description: "UTC - 2", },
    { id: -1, description: "UTC - 1", }]);

    const initDataObject = {
        idUser: params.idUser, username: params?.username, password: params?.password, firstName: params?.firstName, lastName: params?.lastName,
        email: params.email === undefined ? params.username : params.email, country: params?.country, organisation: params?.organisation,
        orgtype: params?.orgtype, enabled: params.enabled === undefined ? false : params.enabled, status: params.status === undefined ? "waiting" : params.status,
        emailOption: params.emailOption === undefined ? "html" : params.emailOption, notes: params?.notes,
        utcOffset: params.utcOffset === undefined ? 0 : params?.utcOffset,
        addresses: params?.addresses ? params.addresses : [],
        services: params?.services ? params.services : [],
    }
    const initState = { enabledToSave: false, isModified: false };
    const [user, setUser] = React.useState(initDataObject);
    const [responseMessage, setResponseMessage] = React.useState("");
    const [isValid, setIsValid] = React.useState(false);

    useEffect(() => {
        GetCountries();
        GetorganizationTypes();
    }, []);

    const handleChangeCustom = (event) => {
        const obj = { ...user };
        obj[event.target.name] = event.target.value;
        setUser(obj);
    }

    const checkValidation = Yup.object().shape({
        firstName: Yup.string().required("First Name is required"),
        lastName: Yup.string().required("Last Name is required"),
        email: Yup.string().required("Email address is required"),
        country: Yup.string().required("Country is required"),
    })

    async function GetCountries() {
        var url = getAPI() + `api/register/Definition/countries/`;
        const response = await fetch(url);
        if (!response.ok) {
            setEvents('Failed to retreive country data.');
            return;
        }
        const countryData = await response.json();
        if (countryData) {
            setCountries(countryData);
        }
    }

    async function GetorganizationTypes() {
        var url = getAPI() + `api/register/Definition/organizationtype/`;
        const response = await fetch(url);
        if (!response.ok) {
            setEvents('Failed to retreive organisation types data.');
            return;
        }
        const organizationData = await response.json();
        if (organizationData) {
            setOrganizationsTypes(organizationData);
        }
    }

    const handleFormikSubmit = (values, { setSubmitting }) => {
        setSubmitting(false);
    }

    React.useEffect(() => {
        props.onChange(user);
        props.onChangeField(user);
    }, [user, isValid]);


    return (
        <Formik
            validateOnChange
            initialValues={user}
            validationSchema={checkValidation}
            onSubmit={handleFormikSubmit}
        >
            {({
                values,
                touched,
                errors,
                isSubmitting,
                handleChange,
                handleBlur,
                handleSubmit
            }) => (
                <div className="container">
                    <form onSubmit={handleSubmit}>
                        <h4 className="d-flex justify-content-center hr-title">Compile Credentials</h4>
                        <br />
                        {width > breakpoint &&
                            <GdacsTimeline navIndex={navIndex} user={params.idUser} />

                        }
                        {width < breakpoint &&
                            <>
                                {props.params.idUser === 0 &&
                                    <ProgressBar>
                                        <ProgressBar variant={"YOU_PICK_A_NAME"} now={20} />
                                        <ProgressBar variant={"YOU_PICK_A_NAME"} now={20} label={2} />
                                    </ProgressBar>
                                }
                                {props.params.idUser !== 0 &&

                                    <ProgressBar variant={"YOU_PICK_A_NAME"} now={25} label={1} />

                                }
                            </>
                        }
                        <br />
                        <br />
                        <fieldset>
                            {width > breakpoint &&
                                <FormGroup id="1" className="form-group">
                                    <Form.Row className="form-row">
                                        <div className="col-6">
                                            <Form.Label className="label-user" htmlFor="firstName">First Name * :</Form.Label>
                                            <Form.Control size="sm" className="form-control form-control-sm" name="firstName" type="text" placeholder="Enter your Name" value={values.firstName} onChange={e => {
                                                handleChange(e);
                                                handleChangeCustom(e);
                                            }} onBlur={handleBlur} className={errors.firstName && touched.firstName && "error"} required />
                                            {errors.firstName && touched.firstName && (
                                                <div className="input-feedback">{errors.firstName}</div>
                                            )}
                                            {responseMessage &&
                                                <div id="firstName" className="input-feedback">{responseMessage}</div>
                                            }
                                        </div>
                                        <div className="col-6">
                                            <Form.Label className="label-user" htmlFor="lastName">Last Name * :</Form.Label>
                                            <Form.Control size="sm" className="form-control form-control-sm" name="lastName" type="text" placeholder="Enter your Surname" value={values.lastName} onChange={e => {
                                                handleChange(e);
                                                handleChangeCustom(e);
                                            }} onBlur={handleBlur} className={errors.lastName && touched.lastName && "error"} required />
                                            {errors.lastName && touched.lastName && (
                                                <div className="input-feedback">{errors.lastName}</div>
                                            )}
                                            {responseMessage &&
                                                <div id="lastName" className="input-feedback">{responseMessage}</div>
                                            }
                                        </div>

                                    </Form.Row>
                                    <Form.Row className="form-row">
                                        <div className="col-6">
                                            <Form.Label className="label-user" htmlFor="email">Main Email Address * :</Form.Label>
                                            <Form.Control size="sm" className="form-control form-control-sm" name="email" type="text" placeholder="Enter your mail" value={values.email} onChange={e => {
                                                handleChange(e);
                                                handleChangeCustom(e);
                                            }} onBlur={handleBlur} className={errors.email && touched.email && "error"} required />
                                            {errors.email && touched.email && (
                                                <div className="input-feedback">{errors.mail}</div>
                                            )}
                                            {responseMessage &&
                                                <div id="email" className="input-feedback">{responseMessage}</div>
                                            }
                                        </div>
                                        <div className="col-6">
                                            <Form.Label className="label-user" htmlFor="emailOption">Address options :</Form.Label>
                                            <select key="emailOption" className="form-control form-control-sm" name="emailOption" onChange={e => {
                                                handleChange(e);
                                                handleChangeCustom(e);
                                            }}>
                                                {emailOpt.map((item) => (
                                                    <option value={item.description} key={item.description} selected={values.emailOption === item.description }>{item.description}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </Form.Row>
                                    <Form.Row className="form-row">
                                        <div className="col-6">
                                            <Form.Label className="label-user" htmlFor="country">Select your country * :</Form.Label>
                                            <select key="country" className="form-control form-control-sm" name="country" onChange={e => {
                                                handleChange(e);
                                                handleChangeCustom(e);
                                            }}>
                                                {countries.map((item) => (
                                                    <option value={item.countryname} key={item.countryname} defaultValue={"-- please select a country --"} selected={values.country === item.countryname}>{item.countryname}</option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="col-6">
                                        <Form.Label className="label-user" htmlFor="utcOffset">Time Zone :</Form.Label>
                                        <select key="utcOffset" className="form-control form-control-sm" name="utcOffset" onChange={e => {
                                                handleChange(e);
                                                handleChangeCustom(e);
                                            }}>
                                            {utcOffset.map((item) => (
                                                <option value={item.id} key={item.id} selected={values.utcOffset === item.id}>{item.description}</option>
                                            ))}
                                            </select>
                                        </div>
                                    </Form.Row>
                                    <br />
                                    <Form.Row className="form-row">
                                        <div className="col-6">
                                            <Form.Label className="label-user" htmlFor="organisation">Organization :</Form.Label>
                                            <Form.Control size="sm" className="form-control form-control-sm" name="organisation" type="text" placeholder="Enter your organization" value={values.organisation} onChange={e => {
                                                handleChange(e);
                                                handleChangeCustom(e);
                                            }} className={errors.organisation && touched.organisation && "error"} />
                                            {errors.organisation && touched.organisation && (
                                                <div className="input-feedback">{errors.organisation}</div>
                                            )}
                                        </div>
                                        <div className="col-6">
                                            <Form.Label className="label-user" htmlFor="orgtype">Select your organization type :</Form.Label>
                                            <select key="OrgType" className="form-control form-control-sm" name="orgtype" onChange={e => {
                                                handleChange(e);
                                                handleChangeCustom(e);
                                            }}>
                                                {organizationtypes.map((item) => (
                                                    <option value={item.description} key={item.description} selected={values.orgtype === item.description}>{item.description}</option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="col-12">
                                            <Form.Label className="label-user" htmlFor="reason">
                                                Reason for registration
                                            </Form.Label>
                                            <Form.Control as="textarea" size="sm" className="form-control form-control-sm" name="notes" type="text" placeholder="" value={values.notes} onChange={e => {
                                                handleChange(e);
                                                handleChangeCustom(e);
                                            }} className={errors.notes && touched.notes && "error"} />
                                            {errors.notes && touched.notes && (
                                                <div className="input-feedback">{errors.notes}</div>
                                            )}
                                        </div>
                                    </Form.Row>
                                    <br />
                                </FormGroup>
                            }
                            {width < breakpoint &&
                                <FormGroup id="1" className="form-group">
                                    <br />
                                    <Form.Row className="form-row">
                                        <div className="col-12">
                                            <Form.Label className="label-user" htmlFor="firstName">First Name * :</Form.Label>
                                            <Form.Control size="sm" className="form-control form-control-sm" name="firstName" type="text" placeholder="Enter your Name" value={values.firstName} onChange={e => {
                                                handleChange(e);
                                                handleChangeCustom(e);
                                            }} className={errors.firstName && touched.firstName && "error"} />
                                            {errors.firstName && touched.firstName && (
                                                <div className="input-feedback">{errors.firstName}</div>
                                            )}
                                        </div>
                                    </Form.Row>
                                    <Form.Row className="form-row">
                                        <div className="col-12">
                                            <Form.Label className="label-user" htmlFor="lastName">Last Name * :</Form.Label>
                                            <Form.Control size="sm" className="form-control form-control-sm" name="lastName" type="text" placeholder="Enter your Surname" value={values.lastName} onChange={e => {
                                                handleChange(e);
                                                handleChangeCustom(e);
                                            }} className={errors.lastName && touched.lastName && "error"} />
                                            {errors.lastName && touched.lastName && (
                                                <div className="input-feedback">{errors.lastName}</div>
                                            )}
                                        </div>
                                    </Form.Row>
                                    <Form.Row className="form-row">
                                        <div className="col-12">
                                            <Form.Label className="label-user" htmlFor="email">Main Email Address * :</Form.Label>
                                            <Form.Control size="sm" className="form-control form-control-sm" name="email" type="text" placeholder={values.username} value={values.email} onChange={e => {
                                                handleChange(e);
                                                handleChangeCustom(e);
                                            }} className={errors.mail && touched.mail && "error"} />
                                            {errors.mail && touched.mail && (
                                                <div className="input-feedback">{errors.mail}</div>
                                            )}
                                        </div>
                                    </Form.Row>
                                    <Form.Row className="form-row">
                                        <div className="col-12">
                                            <Form.Label className="label-user" htmlFor="emailOption">Address options :</Form.Label>
                                            <select key="emailOption" className="form-control form-control-sm" name="emailOption" onChange={e => {
                                                handleChange(e);
                                                handleChangeCustom(e);
                                            }}>
                                            {emailOpt.map((item) => (
                                                <option value={item.description} key={item.description} selected={values.emailOption === item.description}>{item.description}</option>
                                            ))}
                                            </select>
                                        </div>
                                    </Form.Row>
                                    <br />
                                    <Form.Row className="form-row">
                                        <div className="col-12">
                                            <Form.Label className="label-user" htmlFor="country">Select your country * :</Form.Label>
                                            <select key="country" className="form-control form-control-sm" name="country" onChange={e => {
                                                handleChange(e);
                                                handleChangeCustom(e);
                                            }}>
                                                {countries.map((item) => (
                                                    <option value={item.countryname} key={item.countryname} defaultValue={"-- please select a country --"} selected={values.country === item.countryname}>{item.countryname}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </Form.Row>
                                    <br />
                                    <Form.Row className="form-row">
                                        <div className="col-12">
                                        <Form.Label className="label-user" htmlFor="utcOffset">Time Zone :</Form.Label>
                                        <select key="utcOffset" className="form-control form-control-sm" name="utcOffset" onChange={e => {
                                                handleChange(e);
                                                handleChangeCustom(e);
                                            }}>
                                                {utcOffset.map((item) => (
                                                    <option value={item.id} key={item.id} selected={values.utcOffset === item.description}>{item.description}</option>
                                                ))}
                                            </select>
                                        </div>

                                    </Form.Row>
                                    <br />
                                    <Form.Row className="form-row">
                                        <div className="col-12">
                                            <Form.Label className="label-user" htmlFor="organisation">Organization :</Form.Label>
                                            <Form.Control size="sm" className="form-control form-control-sm" name="organisation" type="text" placeholder="Enter your organisation" value={values.organisation} onChange={e => {
                                                handleChange(e);
                                                handleChangeCustom(e);
                                            }} className={errors.organisation && touched.organisation && "error"} />
                                            {errors.organisation && touched.organisation && (
                                                <div className="input-feedback">{errors.organisation}</div>
                                            )}
                                        </div>
                                    </Form.Row>
                                    <Form.Row className="form-row">
                                        <div className="col-12">
                                            <Form.Label className="label-user" htmlFor="orgtype">Select your organization type :</Form.Label>
                                            <select className="form-control form-control-sm" name="orgtype" onChange={e => {
                                                handleChange(e);
                                                handleChangeCustom(e);
                                            }}>
                                                {organizationtypes.map((item) => (
                                                    <option value={item.description} key={item.description} selected={values.orgtype === item.description}>{item.description}</option>
                                                ))}
                                            </select>

                                        </div>
                                    </Form.Row>
                                    <br />
                                    <Form.Row className="form-row">
                                        <div className="col-12">
                                            <Form.Label className="label-user" htmlFor="reason">
                                                Reason for registration
                                            </Form.Label>
                                            <Form.Control as="textarea" size="sm" className="form-control form-control-sm" name="notes" type="text" placeholder="" value={values.notes} onChange={e => {
                                                handleChange(e);
                                                handleChangeCustom(e);
                                            }} className={errors.notes && touched.notes && "error"} />
                                            {errors.notes && touched.notes && (
                                                <div className="input-feedback">{errors.notes}</div>
                                            )}
                                        </div>
                                    </Form.Row>
                                    <br />
                                </FormGroup>
                            }
                        </fieldset>
                    </form>
                </div>
            )}
        </Formik>
    )

}

export { UserCredentials }